import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { CookieService } from 'ngx-cookie-service';
import { StoreService } from '../../_services/store.service';
import { ImagesService } from '../../_services/images.service';
import { environment } from '../../../environments/environment';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-store-media',
    templateUrl: './store-media.component.html',
    styleUrls: ['./store-media.component.css'],
})
export class StoreMediaComponent implements OnInit {
    tabitems: any = [];

    storeId: any;
    selectedStore: any;
    cookieStore: any;
    storeForm: FormGroup;

    role: any;
    routeRole: any;

    addMediaModal = false;
    mediaUploadType: any; // used to handle featured image upload against normal image upload
    imagesArray: any[] = [];
    selectedProductImagesArray: any[] = [];
    imageBase64: any;

    chooseFromImageBank = false;
    uploadNew = false;

    constructor(
        public fb: FormBuilder,
        public activatedRoute: ActivatedRoute,
        public loader: LoadingBarService,
        public notificationService: NotificationService,
        public globals: Globals,
        public cookieService: CookieService,
        public router: Router,
        public _storeService: StoreService,
        public _imagesService: ImagesService,
        public confirmationService: ConfirmationService
    ) {
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            this.storeId = this.cookieStore.id;
        } else {
            this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
        }

        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        this.tabitems = [
            { path: '/' + this.routeRole + '/store/details', title: 'Details' },
            { path: '/' + this.routeRole + '/store/location', title: 'Location' },
            { path: '/' + this.routeRole + '/store/opening-times', title: 'Ordering Times' },
            { path: '/' + this.routeRole + '/store/media', title: 'Media' },
            { path: '/' + this.routeRole + '/store/payment-setup', title: 'Payment Setup' },
            { path: '/' + this.routeRole + '/store/pos-setup', title: 'POS Setup' },
            { path: '/' + this.routeRole + '/store/services', title: 'Services' },
        ];
    }

    ngOnInit() {
        this.getStore(this.storeId);
    }

    // Get Store by id
    public getStore(id) {
        this._storeService.getStoreById(id).subscribe(
            (data: any) => {
                // console.log(data);
                this.selectedStore = data;
                if (this.selectedStore.featuredImage !== null) {
                    this.selectedStore.featuredImageObj = this.selectedStore.featuredImage;
                    this.selectedStore.featuredImage =
                        environment.dcSpacesUrl +
                        'images/' +
                        this.storeId +
                        '/' +
                        this.selectedStore.featuredImage.name;
                }
                if (this.selectedStore.logoImage !== null) {
                    this.selectedStore.logoImageObj = this.selectedStore.logoImage;
                    this.selectedStore.logoImage =
                        environment.dcSpacesUrl +
                        'images/' +
                        this.storeId +
                        '/' +
                        this.selectedStore.logoImage.name;
                }
                if (
                    data.storeConfig !== null &&
                    data.storeConfig.deliveryOrders &&
                    this.tabitems.filter((item) => item.title === 'Delivery Times').length === 0
                ) {
                    this.tabitems.push({
                        path: '/' + this.routeRole + '/store/delivery-times',
                        title: 'Delivery Times',
                    });
                } else if (
                    data.storeConfig !== null &&
                    data.storeConfig.deliveryOrders === false &&
                    this.tabitems.filter((item) => item.title === 'Delivery Times').length === 1
                ) {
                    this.tabitems.splice(
                        this.tabitems.findIndex((item) => item.title === 'Delivery Times'),
                        1
                    );
                }
                if (
                    data.storeConfig !== null &&
                    data.storeConfig.kioskOrders &&
                    this.tabitems.filter((item) => item.title === 'Kiosks').length === 0
                ) {
                    this.tabitems.push({ path: '/' + this.routeRole + '/store/kiosks', title: 'Kiosks' });
                } else if (
                    data.storeConfig !== null &&
                    data.storeConfig.kioskOrders === false &&
                    this.tabitems.filter((item) => item.title === 'Kiosks').length === 1
                ) {
                    this.tabitems.splice(
                        this.tabitems.findIndex((item) => item.title === 'Kiosks'),
                        1
                    );
                }
            },
            (err) => {
                console.log('Getting store by ID error, navigate to select store');
                this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
            }
        );
    }

    // Toggle Media Modal, accounting for param
    public toggleAddMediaModal(type) {
        this.mediaUploadType = type;
        this.addMediaModal = !this.addMediaModal;
        this.getImages(this.storeId);
    }

    // Get All Images
    public getImages(id) {
        this.imagesArray = [];
        this._imagesService.getAllStoreImages(id).subscribe((data: any) => {
            // console.log(data);
            data.forEach((element) => {
                const obj = {
                    imageUrl: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
                    src: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
                    thumb: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
                    imageData: element,
                };
                this.imagesArray.push(obj);
            });
        });
    }

    public selectImageBankImage(image) {
        // console.log('Image to attach - ', image);
        if (this.mediaUploadType === 'featured') {
            this._imagesService
                .addFeaturedImageToStore(this.selectedStore.id, image.imageData.id)
                .subscribe((data: any) => {
                    // console.log('Attach Image Response - ', data);
                    this.addMediaModal = false;
                    this.getStore(this.storeId);
                    this.notificationService.notify(
                        'success',
                        'Image Added',
                        'Store Featured Image has successfully been updated',
                        'top',
                        'right'
                    );
                });
        } else {
            this._imagesService
                .addLogoImageToStore(this.selectedStore.id, image.imageData.id)
                .subscribe((data: any) => {
                    // console.log('Attach Image Response - ', data);
                    this.addMediaModal = false;
                    this.getStore(this.storeId);
                    this.notificationService.notify(
                        'success',
                        'Image Added',
                        'Store Image has successfully been updated',
                        'top',
                        'right'
                    );
                });
        }
    }

    // Uploading
    public onFileChange(event) {
        for (let i = 0; i < event.target.files.length; i++) {
            const file: File = event.target.files[i];
            const myReader: FileReader = new FileReader();
            const that = this;
            if (this.mediaUploadType === 'featured') {
                myReader.onloadend = function(loadEvent: any) {
                    const fileObj = {
                        fileName: event.target.files[i].name,
                        imageBase64: loadEvent.target.result,
                        itemCategoryId: null,
                        itemFeaturedItemId: null,
                        itemImageItemId: null,
                        storeFeaturedImageStoreId: that.selectedStore.idull,
                        storeId: that.storeId,
                        storeLogoStoreId: null,
                    };
                    that.imageBase64 = fileObj;
                    that.uploadImage(fileObj);
                };
                myReader.readAsDataURL(file);
            } else {
                myReader.onloadend = function(loadEvent: any) {
                    const fileObj = {
                        fileName: event.target.files[i].name,
                        imageBase64: loadEvent.target.result,
                        itemCategoryId: null,
                        itemFeaturedItemId: null,
                        itemImageItemId: null,
                        storeFeaturedImageStoreId: null,
                        storeId: that.storeId,
                        storeLogoStoreId: that.selectedStore.id,
                    };
                    that.imageBase64 = fileObj;
                    that.uploadImage(fileObj);
                };
                myReader.readAsDataURL(file);
            }
        }
    }

    public uploadImage(fileObj) {
        this._imagesService.uploadImageToImageBank(fileObj).subscribe((data: any) => {
            this.imagesArray = [];
            this.addMediaModal = false;
            this.getImages(this.storeId);
            this.getStore(this.storeId);
            this.notificationService.notify(
                'success',
                'Image Uploaded',
                'Image Successfully Uploaded and assigned',
                'top',
                'right'
            );
        });
    }

    public removeImage(type) {
        if (type === 'featured') {
            const body = {
                imageId: this.selectedStore.featuredImageObj.id,
                storeFeaturedImageStoreId: this.storeId,
            };
            this.confirmationService.confirm({
                message:
                    'Are you sure that you want to remove store featured image? It will not be deleted from Image bank.',
                accept: () => {
                    this._imagesService.removeImageLink(body).subscribe((data: any) => {
                        // console.log(data);
                        this.getStore(this.storeId);
                    });
                },
            });
        } else {
            const body = {
                imageId: this.selectedStore.logoImageObj.id,
                storeLogoStoreId: this.storeId,
            };
            this.confirmationService.confirm({
                message:
                    'Are you sure that you want to remove store logo image? It will not be deleted from Image bank.',
                accept: () => {
                    this._imagesService.removeImageLink(body).subscribe((data: any) => {
                        // console.log(data);
                        this.getStore(this.storeId);
                    });
                },
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/indi-store/media/store-media.component.ts